import Vue from 'vue';
import routes from './routes';
import Router from 'vue-router';
import Meta from 'vue-meta';

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

router.beforeEach((to, from, next) => {
  /* this will recursively go up from child to parent,
   * useful if utilizing children routes. otherwise,
   * I don't need it.
   */
  let matchedObject = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.hasOwnProperty('windowRedirectAfter'));
  if (matchedObject) {
    if (matchedObject.meta.windowRedirectAfter === true) {
      window.location.href = to.fullPath;
      return;
    }
  } else if (to.matched.length === 0) {
    next('/404');
  } else {
    next();
  }
});

export default router;
